import { PaymentMethod } from '@stripe/stripe-js';
import { IPostPaymentActions } from '~/components/ClientExperience/services/pay.service';
import { TTrackFunction } from '~/common/useAnalytics';
import { LoggerService } from '~/services/logger/logger.service';
import {
    IPaymentMethodResponse,
    IFlowUpdatedResponse
} from '~/types/server.types';

export enum PaymentMethodType {
    BankAccount = 'PaymentMethodChargeableBankAccount',
    CreditCard = 'PaymentMethodStripeCard',
    FinanceApp = 'PaymentMethodFinanceApp'
}

type ccProcessors =
    | 'visa'
    | 'mastercard'
    | 'amex'
    | 'discover'
    | 'unionpay'
    | 'jcb'
    | '';
export type CreditCardProcessor = ccProcessors | Uppercase<ccProcessors>;

export type TChargeStatus = 'status' | 'lastReceipt' | 'charge';

// Props for the payment action
export interface IPayProps {
    stripePaymentMethod?: PaymentMethod;
    track: TTrackFunction;
    executeHBRecaptchaV3?: (action: string) => Promise<string>; // for public flows pay
    gratuity?: number;
    paymentId?: string;
    autoPay?: boolean;
    shouldExecutePayment?: boolean;
    logger?: LoggerService;
    shouldAddPaymentMethod?: boolean;
    paymentMethodId?: string;
}

export interface IInitiatePaymentProps {
    paymentMethod?: PaymentMethod;
    paymentMethodId?: string;
    paymentId: string;
    track: TTrackFunction;
    logger: LoggerService;
    gratuity: number;
    activateAutoPay: boolean;
}

export interface IPayWithPaymentMethodProps {
    paymentMethodId: string;
    autoPay?: boolean;
    gratuity?: number;
    paymentId: string;
    postPaymentActions: IPostPaymentActions;
}

export interface IPaidPaymentInfo {
    charge_id: string;
    amount: number;
    gratuity: number;
    payment_id: string;
    charge_statement_descriptor: string;
    payer_name: string;
    payer_email: string;
    payment_number: number;
    charge_date: string;
    payment_method_last4?: string;
    payment_method_type_name?: string;
    payment_method_type?: PaymentMethodType;
}

export interface IPayActionResponse {
    createdPaymentMethod: string;
    createdPaymentMethodResp: IPaymentMethodResponse;
    paidPaymentInfo: IPaidPaymentInfo;
}

export interface IInitPaymentActionResponse extends IFlowUpdatedResponse {
    payment_method: IPaymentMethodResponse;
    client_secret: string;
    statement_description: string;
    charge_id: string;
    amount: number;
    requires_confirmation: boolean;
}

export interface ISetPaymentAsChargedProps {
    paymentId: string;
    chargeId: string;
    paymentMethodId: string;
    logger: LoggerService;
    activateAutoPay: boolean;
}

export const NUMBER_OF_DAYS_CONSIDER_PAID = 7;
